enum Device {
  TV = 'TV',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  Desktop = 'Desktop',
  GamesConsole = 'Games Console',
}

export default Device;
